// removed by extract-text-webpack-plugin
module.exports = {"form":"src-components-ContactForm----contact-module---form---1Tuzy","input":"src-components-ContactForm----contact-module---input---2__s0","hidden":"src-components-ContactForm----contact-module---hidden---2auRA","textarea":"src-components-ContactForm----contact-module---textarea---_xs_s","test":"src-components-ContactForm----contact-module---test---3zjlt src-components-ContactForm----contact-module---input---2__s0","submit":"src-components-ContactForm----contact-module---submit---3Ngv_","pulse":"src-components-ContactForm----contact-module---pulse---3hUYY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactForm/contact.module.sass
// module id = 355
// module chunks = 114276838955818